import { createEquipmentCategory, defaultAccessorials } from './internal.ts'

export const intermodalEquipment = createEquipmentCategory(
  {
    bucket: 'intermodal',
    mode: 'intermodal',
    workflows: ['truckload'],
    accessorialTypes: defaultAccessorials,
  },
  [
    { key: 'intermodal-20', name: "Intermodal 20'" },
    { key: 'intermodal-40', name: "Intermodal 40'" },
    { key: 'intermodal-45', name: "Intermodal 45'" },
    { key: 'intermodal-48', name: "Intermodal 48'" },
    { key: 'intermodal-53', name: "Intermodal 53'" },
  ],
)
